import { Component, NgZone } from "@angular/core";
import {
  IonicPage,
  NavController,
  ViewController,
  LoadingController,
  AlertController,
  App
} from "ionic-angular";
import { AuthService } from "../../services/AuthService";
import { TabsPage } from "../tabs/tabs";
import { FirestoreService } from "../../services/FirestoreService";
import firebase from "firebase";

@IonicPage()
@Component({
  selector: "page-sign-in",
  templateUrl: "sign-in.html"
})
export class SignInPage {
  loginData: any;

  constructor(
    private navCtrl: NavController,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private app: App,
    private zone: NgZone,
    private firestoreService: FirestoreService,
    private authService: AuthService,
    private alertCtrl: AlertController
  ) {
    this.loginData = { email: "", password: "" };
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad SignInPage");

    let uid = localStorage.getItem('loggedInUserUID')
    this.authService.afAuth.authState.subscribe((user: firebase.User) => {
      if (user && (uid !== null)) {
        console.log(user);
        //this.app.getRootNav().setRoot(TabsPage);

        this.firestoreService.checkIfSubscribed(uid).then((res: any) => {


          if(res.isSubscribed && user.emailVerified) {
            this.app.getRootNav().setRoot(TabsPage);
           // console.log(JSON.stringify(x));
          }

          if(res.isSubscribed && !user.emailVerified) {
            let alert4 = this.alertCtrl.create({
              title: "Information",
              subTitle: 'Please check your email to verify your email address.',
              buttons: ["Dismiss"]
            });
            alert4.present();
          }

          if(!res.isSubscribed && !user.emailVerified) {
            let alert4 = this.alertCtrl.create({
              title: "Information",
              subTitle: 'Please check your email to verify your email address.',
              buttons: ["Dismiss"]
            });
            alert4.present();
          }

          if(!res.isSubscribed && user.emailVerified) {
            this.app.getRootNav().setRoot(TabsPage);
          }
        })
      }


    }, error => {
      console.error(JSON.stringify(error));
    });

  }

  signIn() {
    var loading = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Logging in..."
    });

    loading.present();

    this.authService
      .signIn(this.loginData.email, this.loginData.password)
      .then(x => {
        loading.dismiss();

        //Check subscription
        let uid = localStorage.getItem('loggedInUserUID');
        this.firestoreService.checkIfSubscribed(uid).then((res: any) => {
          localStorage.setItem('loggedInUserEmail', this.loginData.email);

          if(res.isSubscribed) {
            //Update push token
            let pushToken = localStorage.getItem('loggedInPushToken');
            this.firestoreService.updatePushToken(pushToken);
            this.app.getRootNav().setRoot(TabsPage);
            console.log(JSON.stringify(x));
          } else {
            //Check if account is processing
            this.firestoreService.getStripeSubscriptionStatus(uid).then((res: any) => {
              if(res.status) {
                let alert3 = this.alertCtrl.create({
                  title: "Information",
                  subTitle: 'Please wait a short while. Your payment is being processed.',
                  buttons: ["Dismiss"]
                });
                alert3.present();

                let uid = localStorage.getItem('loggedInUserUID');
                    let uuid = localStorage.getItem('deviceUuid');
                    this.authService.handleAccountLoginsOnLogout();
                    this.firestoreService.removeDeviceWithUUID(uid, uuid)

                firebase
                .auth()
                .signOut()
                .then(() => {
                  this.zone.run(() => {
                    //
                  });
                });
              } else {
                let pushToken = localStorage.getItem('loggedInPushToken');
                this.firestoreService.updatePushToken(pushToken);
                this.app.getRootNav().setRoot(TabsPage);
              }
            });


          }
        })


      })
      .catch(error => {
        loading.dismiss();
        console.log(error);
        //alert(error)

        if(error == true) {
          let alert1 = this.alertCtrl.create({
            title: "Log In Error",
            subTitle: 'You need to verify your email before logging in.',
            buttons: ["Dismiss"]
          });
          alert1.present();
        } else if(error == 'subscription') {
          this.app.getRootNav().push("SubscriptionsPage");
        } else {
          let alert2 = this.alertCtrl.create({
            title: "Log In Error",
            subTitle: error.message,
            buttons: ["Dismiss"]
          });
          alert2.present();
        }


      });
  }



  signInWithFacebook() {
    var loading = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Logging in with Facebook..."
    });

    loading.present();

    this.authService
      .signInWithFacebookPlugin()
      .then((res) => {
        console.log('1 :>> ', res);

        this.navCtrl.setRoot(TabsPage);

        loading.dismiss();
      })
      .catch(error => {
        // Known Ionic View restriction
        if (error == "plugin_not_installed") {
          this.showIonicViewErrorMessage().then(() => {
            this.authService
              .signInWithFacebookWeb()
              .then((res) => {
                console.log('2 :>> ', res);
                loading.dismiss();
              })
              .catch(error => {
                console.log('e2 :>> ', error);
                loading.dismiss();
                this.handleFacebookLoginError(error);
              });
          });
        } else {
          loading.dismiss();
          console.log('e3 :>> ', error);
          this.handleFacebookLoginError(error);
        }
      });
  }

  signInWithGoogle(): void {
    var loading = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Logging in with Google..."
    });

    loading.present();

    this.authService
      .signInWithGooglePlugin()
      .then(() => {
        loading.dismiss();
      })
      .catch(error => {
        // Known Ionic View restriction
        if (error == "plugin_not_installed") {
          this.showIonicViewErrorMessage().then(() => {
            this.authService
              .signInWithGoogleWeb()
              .then(() => {
                loading.dismiss();
              })
              .catch(error => {
                loading.dismiss();
                this.handleGoogleLoginError(error.message);
              });
          });
        } else {
          loading.dismiss();
          this.handleGoogleLoginError(error.message);
        }
      });
  }

  signInWithTwitter(): void {
    var loading = this.loadingCtrl.create({
      spinner: "bubbles",
      content: "Logging in with Twitter..."
    });

    loading.present();

    this.authService
      .signInWithTwitterPlugin()
      .then(() => {
        loading.dismiss();
      })
      .catch(error => {
        // Known Ionic View restriction
        if (error == "plugin_not_installed") {
          this.showIonicViewErrorMessage().then(() => {
            this.authService
              .signInWithTwitterWeb()
              .then(() => {
                loading.dismiss();
              })
              .catch(error => {
                loading.dismiss();
                this.handleTwitterLoginError(error.message);
              });
          });
        } else {
          loading.dismiss();
          this.handleTwitterLoginError(error.message);
        }
      });
  }

  showIonicViewErrorMessage() {
    return new Promise((resolve, reject) => {
      let alert = this.alertCtrl.create({
        title: "Ionic View Login Error",
        subTitle:
          "Ionic View does not currently support this login plugin. Logging in using web...",
        buttons: [
          {
            text: "OK",
            handler: () => {
              alert.dismiss().then(() => {
                resolve();
              });
            }
          }
        ]
      });

      alert.present();
    });
  }

  handleFacebookLoginError(error) {
    let alert = this.alertCtrl.create({
      title: "Facebook Login Error",
      subTitle: error,
      buttons: ["Dismiss"]
    });

    alert.present();
  }

  handleGoogleLoginError(error) {
    let alert = this.alertCtrl.create({
      title: "Google Login Error",
      subTitle: error,
      buttons: ["Dismiss"]
    });

    alert.present();
  }

  handleTwitterLoginError(error) {
    let alert = this.alertCtrl.create({
      title: "Twitter Login Error",
      subTitle: error,
      buttons: ["Dismiss"]
    });

    alert.present();
  }

  goToSignUp() {
    if (this.navCtrl.canGoBack()) {
      this.viewCtrl.dismiss();
    } else {
      this.navCtrl.push("SignUpPage");
    }
  }

  //MrScript263
  goToForgotPassword() {
    if (this.navCtrl.canGoBack()) {
      this.viewCtrl.dismiss();
    } else {
      this.navCtrl.push("ForgotPasswordPage");
    }
  }

  ionViewWillLoad() {
    localStorage.setItem('runOrangeCron', '1');
  }


}



// WEBPACK FOOTER //
// ./src/pages/sign-in/sign-in.ts